module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_7016.0c8c66f2.png";